import React from 'react'; 
import './footer.css'

export default function FooterWrapper(props) { 
    return ( <>
        <footer className={`${props.className}`}>
            <div> 
                 {props.children}
            </div>
        </footer>
    </>)
}
  